import React from "react";
import { Urls } from "../constants/UrlConstants";

const Footer = {
  HeaderText: {
    HOL: "Health Hub",
    MOL: "HEALTH SUPPORT"
  },
  WebAppName: {
    HOL: "Health-on-Line",
    MOL: "AXA"
  },
  FooterMenuText: {
    HOL: "24/7 health support line",
    MOL: "24/7 health support line"
  },
  PrivacyPolicyUrl: {
    International: Urls.PrivacyUrl.International,
    HOL: Urls.PrivacyUrl.HOL,
    MOL: Urls.PrivacyUrl.MOL
  },
  CookiePolicyUrl: {
    MOL: Urls.CookiePolicyUrl.MOL,
    HOL: Urls.CookiePolicyUrl.HOL
  },
  AxaHealthAbout: Urls.AxaHealthAboutUrl,
  ContactUsUrl: {
    HOL: Urls.HOLContactUs,
    Any: Urls.AXAContactUs
  },
  CopyrightText: {
    International: (
      <React.Fragment>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={Urls.PrivacyUrl.International}
          >
            Privacy Policy
          </a>
        </li>
        <li>© {new Date().getFullYear()} AXA All Rights Reserved</li>
      </React.Fragment>
    ),
    MOL: (
      <React.Fragment>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={Urls.PrivacyUrl.MOL}
          >
            Privacy Policy
          </a>
        </li>
        <li>© {new Date().getFullYear()} AXA All Rights Reserved</li>
      </React.Fragment>
    ),
    HOL: (
      <React.Fragment>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={Urls.PrivacyUrl.HOL}
          >
            Privacy Policy
          </a>
        </li>
        <li>© {new Date().getFullYear()} Health-on-Line All Rights Reserved</li>
      </React.Fragment>
    )
  },
  CopyrightSuffix: {}
};
export default Footer;
